import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { grid } from '@/css/resources/placeholders.css';
import { fluidValues } from '@/css/resources/mixins.css';

const getStyles = () =>
	css({
		'.supt-seasonPage__list-shows-events': cssObj(
			grid,
			fluidValues('paddingTop', 100, 150),
			{
				'.supt-listCards': {
					gridColumn: '1/ span 12',
				},
			}
		),

		'.supt-filters + *': cssObj(fluidValues('paddingTop', 50, 80)),
	});

export { getStyles };
